<footer class="page-footer darkFooter footer-style" id="footerStyle">
  <div class="container-fluid">




    <div class="row justify-content-center">
      <div class="col-12">
        <nav class="nav justify-content-center align-items-center foo-links">
          <a href="https://www.mihuru.com/privacy/privacy" target="_blank" class="nav-link">Privacy policy</a>
          <a href="https://www.mihuru.com/privacy/terms" target="_blank" class="nav-link">Terms</a>
          <div class="powered-by-wrapper">
            <span class="powered-by-text">Powered By</span>
            <img src="https://itraveleoblogdiag865.blob.core.windows.net/websiteimages/assets/logos/ExperianLogo.png"
              alt="Experian Logo" class="powered-by-logo">
          </div>
        </nav>
      </div>
    </div>

    <div class="row justify-content-center" *ngIf="lendingPartnerArr && lendingPartnerArr.length > 0">
      <div class="col-12">
        <div class="lending-partners-container">
          <p class="lending-partners-title">Our Lending Partner</p>
          <div class="lending-partners-logos">
            <div *ngFor="let l of lendingPartnerArr" class="partner-logo-item">
              <img [src]="l.image" [style.width.px]="l.width ? +l.width : null"
                [style.height.px]="l.height ? +l.height : null" class="partner-logo" alt="Lending Partner Logo" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
<div *ngIf="shwHubspot" class="modal" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Be Our EdTech Partner</h5>
        <button type="button" class="close" (click)="closeModal()" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-12">
            <div id="hubspotForm">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>